export default "__VITE_ASSET__CKY_uUSM__"